import { Panel } from "../../../components/panels/Panel";
import { PhotoIcon } from "@heroicons/react/20/solid";
import { Fragment, useState } from "react";
import { useGetData } from "../../../services/api/api-tools";
import { Loader } from "../../../components/loading/Loader";
import { formatSecondsToHoursMinutesSeconds } from "../../../helpers/date/date-helper";
import { ImageWithBbox } from "./ImageWithBbox";

export const SnapshotsGalleryPage = () => {

  const [selectedSnapshot, setSelectedSnapshot] = useState(null);

  const snapshots = useGetData(
    'quality_snapshots',
    'quality_snapshots',
  );

  if (snapshots.isLoading) return <Loader/>

  const dataByDay = snapshots.data.sort((a, b) => b.date - a.date).reduce((acc, obj) => {
    const date = new Date(obj.date * 1000);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const key = `${day}/${month}/${year}`;

    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});

  console.log(dataByDay);

  return (
    <>
      <div className='flex h-full'>
        <div className='w-2/3'>
          <Panel category='main' title='GALERIE' noPadding={true}>
            <div className="pt-4">
              {
                Object.entries(dataByDay).map(([date, snapshots], index) => (
                  <Fragment key={index}>
                    <span className="rounded-md bg-perception-gray-800 px-2 py-1 text-xs font-medium text-white inline-block ml-4">
                      {date}
                    </span>

                    <div className="grid grid-cols-6 gap-4 w-full overflow-y-auto p-4">
                      {
                        snapshots.map((snapshot, index) => (
                          <>
                            <div className="h-[200px] w-full aspect-video bg-perception-black-800 bg-cover bg-center rounded-md cursor-pointer transition duration-300 hover:transform hover:scale-105 text-xs flex justify-end items-end relative overflow-hidden"
                              key={index} onClick={() => setSelectedSnapshot(snapshot)}>
                              <ImageWithBbox points={snapshot.bboxes_to_check ? snapshot.bboxes_to_check : []} src={process.env.REACT_APP_ADDRESS + 'public/media/' + snapshot.file_name} />
                              <span className="absolute bottom-4 right-4 rounded-md backdrop-blur-md bg-white/20 px-2 py-1 text-xs font-medium text-white inline-block ml-4">
                                {formatSecondsToHoursMinutesSeconds(snapshot.date)}
                              </span>
                            </div>
                          </>
                        ))
                      }
                    </div>
                  </Fragment>
                ))
              }
            </div>
          </Panel>
        </div>
        <div className="w-1/3">
          <Panel title='&nbsp;' noPadding={true}>
            {
              selectedSnapshot === null ?
                <div className='h-full flex flex-col gap-4 justify-center items-center text-center p-8'>
                  <PhotoIcon className='size-16 cursor-pointer text-perception-black-700' />
                  <div className='text-perception-gray-700 text-xl'>Sélectionnez une photo pour l'afficher en grand</div>
                </div>
              :
                <ImageWithBbox points={selectedSnapshot.bboxes_to_check ? selectedSnapshot.bboxes_to_check : []} src={process.env.REACT_APP_ADDRESS + 'public/media/' + selectedSnapshot.file_name} />
            }
          </Panel>
        </div>
      </div>
    </>
  );
};